/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React                  from 'react'
import Box                    from "@material-ui/core/Box"

import HistoryCreateComponent from '../Components/HistoryCreateComponent'

const HistoryCreatePage = () => {

   return (
      <Box>
         <HistoryCreateComponent />
      </Box>
   )
}

export default HistoryCreatePage
